import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-01d56936")

_pushScopeId("data-v-01d56936")
const _hoisted_1 = { class: "button-status" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Tooltip = _resolveComponent("Tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Tooltip, {
      text: _ctx.t('chat.privateDescription')
    }, {
      button: _withId(() => [
        _createVNode(_component_Button, {
          class: "btn",
          mode: "primary",
          size: "m"
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.t('chat.privateBtn')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["text"])
  ]))
})